var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "showHeader",
      attrs: {
        visible: _vm.drawerVisible,
        wrapperClosable: false,
        direction: "rtl",
        size: "800px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "demo-drawer_title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v("会员权益设置")]
      ),
      _c(
        "div",
        { staticClass: "detailSection" },
        [
          _c(
            "el-form",
            {
              ref: "pram",
              staticClass: "demo-ruleForm px35",
              attrs: {
                model: _vm.pram,
                "label-width": "75px",
                rules: _vm.rules,
              },
            },
            [
              _c("el-form-item", { attrs: { label: "权益名称：" } }, [
                _c(
                  "div",
                  {
                    staticClass: "from-ipt-width el-input el-input--small",
                    attrs: { disabled: "" },
                  },
                  [
                    _c("span", { staticClass: "el-input__inner" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("filterMemberBenefits")(_vm.pram.name)
                          ) +
                          " "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "展示名称：", prop: "value" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: { maxlength: "6" },
                    model: {
                      value: _vm.pram.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "value", $$v)
                      },
                      expression: "pram.value",
                    },
                  }),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "用于用户端-付费会员页面「权益名称」展示，最多支持6个字。"
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "权益图标：", prop: "imageUrl" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox acea-row",
                      on: {
                        click: function ($event) {
                          return _vm.modalPicTap(false)
                        },
                      },
                    },
                    [
                      _vm.pram.imageUrl
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", { attrs: { src: _vm.pram.imageUrl } }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "用于用户端-付费会员页面「权益图标」展示，建议80*80PX，小于5KB。"
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "权益简介：", prop: "message" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: { maxlength: "8", placeholder: "请输入商品简介" },
                    model: {
                      value: _vm.pram.message,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.pram,
                          "message",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "pram.message",
                    },
                  }),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "用于用户端-付费会员页面「权益简介」展示，最多支持8个字。"
                    ),
                  ]),
                ],
                1
              ),
              _vm.pram.name === "integralDoubling" ||
              _vm.pram.name === "experienceDoubling"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "倍数：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            max: 9,
                            step: 1,
                            placeholder: "请输入排序",
                          },
                          model: {
                            value: _vm.pram.multiple,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.pram,
                                "multiple",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "pram.multiple",
                          },
                        }),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v(
                            "付费会员相对普通用户获得积分倍数，支持输入1～9正整数。"
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "翻倍渠道：", required: "" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            on: { change: _vm.checkedBoxChange },
                            model: {
                              value: _vm.pram.channelStrList,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "channelStrList", $$v)
                              },
                              expression: "pram.channelStrList",
                            },
                          },
                          [
                            _vm.pram.name === "integralDoubling"
                              ? [
                                  _c("el-checkbox", { attrs: { label: "1" } }, [
                                    _vm._v("签到"),
                                  ]),
                                  _c("el-checkbox", { attrs: { label: "2" } }, [
                                    _vm._v("购买商品"),
                                  ]),
                                ]
                              : _vm._e(),
                            _vm.pram.name === "experienceDoubling"
                              ? [
                                  _c("el-checkbox", { attrs: { label: "1" } }, [
                                    _vm._v("签到"),
                                  ]),
                                  _c("el-checkbox", { attrs: { label: "2" } }, [
                                    _vm._v("发布种草"),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v(
                            "至少需要选中一项，未选中渠道付费会员进行此操作经验值不翻倍。"
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "排序：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: 10,
                      step: 1,
                      placeholder: "请输入排序",
                    },
                    model: {
                      value: _vm.pram.sort,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.pram,
                          "sort",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "pram.sort",
                    },
                  }),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "数字越大，用户端及管理端列表，此权益的排序越靠前，支持输入0～10整数。"
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", required: "" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-text": "开启",
                      "inactive-text": "关闭",
                      "active-value": true,
                      "inactive-value": false,
                    },
                    model: {
                      value: _vm.pram.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "status", $$v)
                      },
                      expression: "pram.status",
                    },
                  }),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "会员权益关闭之后，不会在用户端展示，付费会员也不能够享受此权益。"
                    ),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "demo-drawer__footer from-foot-btn btn-shadow drawer_fix",
        },
        [
          _c(
            "div",
            { staticClass: "acea-row row-center" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _vm.checkPermi(["platform:paid:member:benefits:edit"])
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "debounceClick",
                          rawName: "v-debounceClick",
                          value: _vm.submitForm,
                          expression: "submitForm",
                        },
                      ],
                      attrs: { type: "primary" },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }